import { combineReducers } from 'redux'
import login from './login/reducers'
import role from './role/reducers'
import user from './user/reducers'
import searchTags from './searchTag/reducers'
import searchFilter from './searchfilter/reducers'
import selectTab from './selectTab/reducers'
import {
  searchInput,
  searchSelectOption,
} from './searchUserManagementBuyer/reducers'
import {
  searchInputFilterSupplier,
  searchSelectOptionSupplier2,
  searchSelectOptionSupplier3,
  searchSelectOptionSupplier4,
} from './searchSupplierManagementBuyer/reducers'
import {
  searchInputFilterSourcing,
  searchSelectOptionSourcing2,
  searchSelectOptionSourcing3,
  searchSelectOptionSourcing4,
  searchSelectOptionSourcing5,
} from './searchSourcingBuyer/reducers'
import {
  searchInputFilterSourcingSupplier,
  searchSelectOptionSourcingSupplier2,
  searchSelectOptionSourcingSupplier3,
  searchSelectOptionSourcingSupplier4,
  searchSelectOptionSourcingSupplierEventType,
} from './searchSourcingSupplier/reducers'
import { resultStartApiReqUnseal } from './requestUnsealTec/reducers'
import { resultStartApiReqUnsealTec } from './requestUnseal/reducers'
import { getFilterDateFrom } from './filterDateFrom/reducers'
import { getFilterDateTo } from './filterDateTo/reducers'
import { getStatusSourcingProjects } from './filterStatusSourcingProjects/reducers'
import { setSourcingEventListFilter } from './filterSourcingEvent/reducers'
import { getFilterPage } from './filterPage/reducers'
import { getFilterPageAllEvent } from './filterPageAllEvent/reducers'
export const rootReducer = () => {
  return combineReducers({
    login,
    role,
    user,
    searchTags,
    searchFilter,
    selectTab,
    searchInput,
    searchSelectOption,
    searchInputFilterSupplier,
    searchSelectOptionSupplier2,
    searchSelectOptionSupplier3,
    searchSelectOptionSupplier4,
    searchInputFilterSourcing,
    searchSelectOptionSourcing2,
    searchSelectOptionSourcing3,
    searchSelectOptionSourcing4,
    searchSelectOptionSourcing5,
    searchInputFilterSourcingSupplier,
    searchSelectOptionSourcingSupplier2,
    searchSelectOptionSourcingSupplier3,
    searchSelectOptionSourcingSupplier4,
    searchSelectOptionSourcingSupplierEventType,
    resultStartApiReqUnseal,
    resultStartApiReqUnsealTec,
    getFilterDateFrom,
    getFilterDateTo,
    getStatusSourcingProjects,
    setSourcingEventListFilter,
    getFilterPage,
    getFilterPageAllEvent,
  })
}
